var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Sanity from "../Sanity";
import axios from "axios";
import { Upload } from 'tus-js-client';
var Uploader = /** @class */ (function () {
    function Uploader(vimeo) {
        var _this = this;
        this.registerCallbacks = function (onSuccessCallback, onProgressCallback, onErrorCallback) {
            _this.onSuccessCallback = onSuccessCallback;
            _this.onProgressCallback = onProgressCallback;
            _this.onErrorCallback = onErrorCallback;
        };
        this.uploadFile = function (file, name, description) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.file = file;
                        this.name = name;
                        this.description = description;
                        return [4 /*yield*/, this.sendVideoCreateRequest()];
                    case 1:
                        _a.sent();
                        this.uploadVideoUsingTus();
                        return [2 /*return*/];
                }
            });
        }); };
        this.clearState = function () {
            _this.file = undefined;
            _this.uploadLink = '';
            _this.name = '';
            _this.description = '';
            if (_this.onErrorCallback)
                _this.onErrorCallback('');
            if (_this.onProgressCallback)
                _this.onProgressCallback(0);
            if (_this.onSuccessCallback)
                _this.onSuccessCallback(false);
        };
        this.sendVideoCreateRequest = function () { return __awaiter(_this, void 0, void 0, function () {
            var headers, body, uploadResponse;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.file)
                            return [2 /*return*/, console.error('No file was available for upload.')];
                        headers = this.vimeo.baseHeader;
                        headers['Accept'] = "application/vnd.vimeo.*+json;version=3.4";
                        body = {
                            description: this.description,
                            name: this.name,
                            upload: {
                                approach: "tus",
                                size: (_a = this.file) === null || _a === void 0 ? void 0 : _a.size
                            }
                        };
                        return [4 /*yield*/, axios.post('https://api.vimeo.com/me/videos', body, { headers: headers })];
                    case 1:
                        uploadResponse = _b.sent();
                        this.uploadLink = uploadResponse.data.upload.upload_link;
                        return [2 /*return*/];
                }
            });
        }); };
        this.uploadVideoUsingTus = function () {
            if (!_this.file)
                return console.error('No file was available for upload.');
            var headers = _this.vimeo.baseHeader;
            headers['Accept'] = "application/vnd.vimeo.*+json;version=3.4";
            _this.currentTusUpload = new Upload(_this.file, {
                uploadUrl: _this.uploadLink,
                retryDelays: [0, 3000, 5000, 10000, 20000],
                metadata: {
                    filename: _this.file.name,
                    filetype: _this.file.type
                },
                headers: headers,
                onError: function (error) {
                    console.log("Failed because: " + error);
                    if (_this.onErrorCallback)
                        _this.onErrorCallback(error.message);
                },
                onProgress: function (bytesUploaded, bytesTotal) {
                    var percentage = bytesUploaded / bytesTotal * 100;
                    console.log(bytesUploaded, bytesTotal, percentage + "%");
                    if (_this.onProgressCallback && percentage > 5)
                        _this.onProgressCallback(percentage);
                },
                onSuccess: function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                console.log("Download %s from %s", (_a = this.currentTusUpload) === null || _a === void 0 ? void 0 : _a.url);
                                return [4 /*yield*/, Sanity.syncer.syncAllVideosWithSanity()];
                            case 1:
                                _b.sent();
                                return [4 /*yield*/, Sanity.paginator.getVideos()];
                            case 2:
                                _b.sent();
                                if (!this.onSuccessCallback)
                                    return [2 /*return*/, console.error('No onSuccess callback was registered.')];
                                this.onSuccessCallback(true);
                                return [2 /*return*/];
                        }
                    });
                }); }
            });
            _this.currentTusUpload.findPreviousUploads().then(function (previousUploads) {
                var _a, _b;
                // Found previous uploads so we select the first one. 
                if (previousUploads.length) {
                    (_a = _this.currentTusUpload) === null || _a === void 0 ? void 0 : _a.resumeFromPreviousUpload(previousUploads[0]);
                }
                // Start the upload
                (_b = _this.currentTusUpload) === null || _b === void 0 ? void 0 : _b.start();
            });
        };
        this.vimeo = vimeo;
    }
    return Uploader;
}());
export { Uploader };
